var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.name !== 'login')?_c('div',{staticClass:"topbar"},[_c('TopBar')],1):_vm._e(),_c('keep-alive',[_c('router-view',{staticClass:"main",style:({
        'margin-top': _vm.$route.name !== 'login' ? '50px' : '0',
        'margin-bottom': _vm.$route.name !== 'login' ? '50px' : '0',
      })}),(_vm.$route.name !== 'login')?_c('Footer',{staticClass:"footer"}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }